module.exports = __webpack_public_path__ + "img/hill21.90520241.jpg";